import { gql } from '@apollo/client/core';

/**
 * Selections for the staff user lookup. Keep this in step with `User.ts` — every field selected
 * here is mapped there, and nothing more is selected than is mapped. Notably `active` is in neither.
 *
 * One fragment rather than a list/detail pair: there is a single screen, and the memberships are
 * what it is for, so there is no lighter row shape worth splitting out.
 */
export const INTERNAL_USER_FIELDS = gql`
  fragment InternalUserFields on User {
    id
    name
    email
    memberships {
      account {
        id
        name
      }
      role
      teamRole
    }
  }
`;
